import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import PublicShell, { WIDE } from "@/components/PublicShell";
import { usePageMeta } from "@/lib/seo";
import { cap } from "@/lib/signFacts";
import { ORDER, pairSlug } from "@/pages/CompatibilityPage";
import { useAuth } from "@/context/AuthContext";

function YourSign({ sign }) {
  return (
    <section data-testid="compat-your-sign" className="mb-6 bg-gradient-to-br from-[#2a2110] to-[#0F1523] border border-[#D4AF37]/50 rounded-2xl p-5">
      <h2 className="text-xl font-light mb-1">Your sign: <span className="gold-text">{cap(sign)}</span></h2>
      <p className="text-sm text-[#A7B0C0] mb-3">Pick the other sign.</p>
      <div className="flex flex-wrap gap-1.5">
        {ORDER.map((b) => (
          <Link key={b} to={`/compatibility/${pairSlug(sign, b)}`} data-testid={`compat-your-${b}`} className="text-sm border border-[#D4AF37]/40 hover:bg-[#D4AF37]/15 text-[#E8DCC4] rounded-full px-3 py-1.5 transition-colors">
            {cap(sign)} × {cap(b)}
          </Link>
        ))}
      </div>
    </section>
  );
}

export default function CompatibilityIndex() {
  const { user } = useAuth();
  const mine = user?.trinity?.sun?.sign?.toLowerCase();
  usePageMeta("Zodiac Compatibility: All 78 Sign Pairings · Astra", "/compatibility",
    "Zodiac compatibility for every pair of star signs: love, friendship, chemistry and friction points, from Aries and Taurus to Pisces and Pisces.");
  return (
    <PublicShell testId="compat-index">
      <div className={`px-5 pt-6 pb-10 fade-up ${WIDE ? "lg:max-w-5xl lg:mx-auto lg:pt-12" : ""}`}>
        <p className="text-[11px] uppercase tracking-[0.3em] gold-text"><Heart size={11} className="inline -mt-0.5 mr-1" />Sign compatibility</p>
        <h1 className="text-4xl sm:text-5xl font-light mt-2 mb-3">Zodiac compatibility</h1>
        <p className="text-base text-[#A7B0C0] mb-6">Pick a pair to read how two signs connect: chemistry, communication, strengths and friction.</p>
        {ORDER.includes(mine) && <YourSign sign={mine} />}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {ORDER.map((a) => (
            <section key={a} data-testid={`compat-index-${a}`} className="bg-[#0F1523]/90 border border-[#D4AF37]/20 rounded-2xl p-4">
              <h2 className="text-lg font-light mb-2">{cap(a)} compatibility</h2>
              <div className="flex flex-wrap gap-1.5">
                {ORDER.map((b) => (
                  <Link key={b} to={`/compatibility/${pairSlug(a, b)}`} data-testid={`compat-index-link-${a}-${b}`} className="text-xs border border-[#D4AF37]/25 hover:bg-[#D4AF37]/10 text-[#E8DCC4] rounded-full px-2.5 py-1 transition-colors">
                    <span className="sr-only">{cap(a)} and </span>{cap(b)}
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </PublicShell>
  );
}
